// Firebase configuration for the `infomotores` project — the same project the
// Flutter app (motor_app) targets. Keep this file in step with
// motor_app/lib/firebase_options.dart and motor_app/android/app/google-services.json.
//
// If the two disagree, web and mobile users end up in separate auth pools and
// separate chat databases while both appear to "work".
import { initializeApp } from "@firebase/app";
import { getAuth } from '@firebase/auth';
import { getDatabase } from '@firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyD7KdBv0mzx6GXcro879N9VFAFXfiCOm4c",
  authDomain: "infomotores.firebaseapp.com",
  projectId: "infomotores",
  storageBucket: "infomotores.firebasestorage.app",
  messagingSenderId: "523334912309",
  appId: "1:523334912309:web:3c42348fb61dae17dce47c",
  measurementId: "G-4GJN9LGL3K"
};

// Realtime Database URL, or null when the project has none.
//
// The default namespace of the `infomotores` project. google-services.json
// predates the database and carries no firebase_url, so this value has to be
// set by hand here and in motor_app/lib/firebase_options.dart — both clients
// must point at the same Message / Current_Chat_With / User_Presence tree or
// web and mobile users cannot see each other's messages.
const databaseUrl = 'https://infomotores-default-rtdb.firebaseio.com';

/** Whether the chat feature can work at all on this project. */
const hasRealtimeDatabase = databaseUrl != null;

// OAuth web client id, used for Google sign-in. Matches the oauth_client entry
// in google-services.json and googleServerClientId in firebase_options.dart.
const googleServerClientId =
  '523334912309-mhv2a9q5vi7etu9r3o9ludfea9mas3ba.apps.googleusercontent.com';

const firebase = initializeApp(
  hasRealtimeDatabase ? { ...firebaseConfig, databaseURL: databaseUrl } : firebaseConfig
);
const auth = getAuth(firebase);
auth.languageCode = 'en';

// getDatabase() throws deep inside the SDK when no URL is configured, which
// would take down whatever screen imported it. Stay null instead, and let
// callers check hasRealtimeDatabase first.
const database = hasRealtimeDatabase ? getDatabase(firebase) : null;

export { firebase, auth, database, hasRealtimeDatabase, googleServerClientId };
